import React from "react";
import { Container } from "reactstrap";
import List from "./List";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";

const Expenses = ({ t }) => {
  document.title = t("document.title.expenses", { PLATFORM_NAME });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            navigation={true}
            title={t("expenses.breadcrumbs.list.title")}
            breadcrumbItem={t("expenses.breadcrumbs.list.breadcrumbItem")}
          />
          <List />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Expenses);
